import { setIsLoading } from '../../../../actions/general';
import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';

export const SET_USER_TESTS = 'setUserTests';

export const API_SUBSCRIBER_USER_TESTS = 'user/test/test-statuses/';

export const setUserTests = (UserTests) => {
     return {
          type: SET_USER_TESTS,
          payload: UserTests,
     };
};

export const fetchUserTestsRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_USER_TESTS, 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setUserTests(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
